import { useEffect } from 'react';

/* Digioh needs to use localstorage to acess pretty much any data.
 * This hook is used in a third party integration that will hide a
 * mailing list form if the user is already a flexcar member. */
export function useDigiohLoginLocalStore(isLoggedIn: boolean) {
  useEffect(() => {
    if (isLoggedIn) {
      localStorage?.setItem('digioh_logged_in', 'true');
    } else {
      localStorage?.setItem('digioh_logged_in', 'false');
    }
  }, [isLoggedIn]);
}
